var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#3F3F3F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.48242,
    y: 6,
    width: 14.1926,
    height: 2.0965,
    rx: 1.04825,
    transform: "rotate(45 7.48242 6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1926,
    height: 2.0965,
    rx: 1.04825,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 7.48242 17.5195)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseButton);
export default __webpack_public_path__ + "static/media/icon-close-button.b94d2b51b4e5c527f7f36c97ea4cdee2.svg";
export { ForwardRef as ReactComponent };